import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminRevisionPreciosBackview } from './admin-revision-precios.component.backview';
import { NgxSpinnerModule } from "ngx-spinner";
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { MatMenuModule } from '@angular/material/menu';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  declarations: [AdminRevisionPreciosBackview],
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    HeaderModule,
    FooterModule,
    MatNativeDateModule,
    MatMenuModule
  ],
  exports: [
    AdminRevisionPreciosBackview
  ]
})
export class AdminRevisionPreciosModule { }
